import { render, staticRenderFns } from "./ExamsNew.vue?vue&type=template&id=5d15b0fc"
import script from "./ExamsNew.vue?vue&type=script&lang=js"
export * from "./ExamsNew.vue?vue&type=script&lang=js"
import style0 from "./ExamsNew.vue?vue&type=style&index=0&id=5d15b0fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports